<template>
  <div class="card-container">
    <common-top-form
      :selectShow="false"
      :model="formModel"
      :submitService="submitService"
      @success="onSuccess"
      @openAddDialog="openDialog"
      addShowPower="/memberupgrade/add"
    >
    </common-top-form>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleChange="getList"
      :isShow="false"
    >
      <el-table-column
        prop="levelName"
        label="等级名称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="fee"
        label="服务费比例"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
        <!-- <template slot-scope="scope">
          <p>{{ toDoubleThousands(scope.row.fee) }}</p>
        </template> -->
      </el-table-column>
      <el-table-column
        prop="withdrawFee"
        label="提现费率(%)"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="withdrawRate"
        label="元/笔"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTablewithdrawRate"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="100"
        v-if="
          hasPerm('/memberupgrade/update') || hasPerm('/memberupgrade/delete')
        "
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="openDialog(scope.row)"
            v-if="hasPerm('/memberupgrade/update')"
            >修改</el-button
          >
          <el-button
            type="text"
            @click="deleteInfo(scope.row)"
            class="button-color"
            v-if="hasPerm('/memberupgrade/delete')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      dialogWidth="640px"
    >
      <div class="flex-row vertical-center flow-justify">
        <el-form-item label="等级名称" prop="levelName" label-width="100px">
          <el-input
            type="text"
            placeholder="请输入"
            maxlength="20"
            show-word-limit
            v-model="dialogModel.levelName"
          ></el-input>
        </el-form-item>
      </div>
      <el-form-item label="服务费比例" prop="fee" label-width="100px">
        <div class="flex-row vertical-center flow-justify">
          <el-input-number
            v-model="dialogModel.fee"
            :controls="false"
            :precision="4"
            :step="0.1"
            controls-position="right"
            :min="0"
            placeholder="请输入"
          ></el-input-number>
        </div>
      </el-form-item>
      <div style="margin-top: 30px">
        <div class="flex-row vertical-center">
          <div
            class="flex-row vertical-center flow-justify"
            style="margin-right: 20px"
          >
            <el-form-item
              prop="withdrawFee"
              label="提现费率"
              label-width="100px"
            >
              <div class="flex-row vertical-center">
                <div class="flex-row vertical-center flow-justify">
                  <el-input-number
                    v-model="dialogModel.withdrawFee"
                    :controls="false"
                    controls-position="right"
                    :min="0"
                    :precision="4"
                    :step="0.1"
                    placeholder="请输入"
                    :max="100"
                  ></el-input-number>
                  <p class="unit">%</p>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="flex-row vertical-center flow-justify">
            <el-form-item prop="withdrawRate">
              <div class="flex-row vertical-center">
                <div class="flex-row vertical-center flow-justify">
                  <el-input-number
                    v-model="dialogModel.withdrawRate"
                    :controls="false"
                    controls-position="right"
                    :min="0"
                    :max="9999999999"
                    placeholder="请输入"
                  ></el-input-number>
                  <p class="unit">元/笔</p>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
      </div>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "@/view/dialog/FormDialog";

import OrganService from "service/OrganService";

import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "memberupgrade",
  data() {
    return {
      formModel: {},
      submitService: OrganService.memberupgradeList,
      tableData: [],
      itemId: "",
      dialogModel: {
        levelName: "",
        fee: undefined,
        withdrawFee: undefined,
        withdrawRate: undefined,
      },
      dialogRules: {
        levelName: [
          {
            required: true,
            message: "请输入",
          },
        ],
        withdrawFee: [
          {
            required: true,
            message: "请输入",
          },
        ],
        withdrawRate: [
          {
            required: true,
            message: "请输入",
          },
        ],
        fee: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value > 1 || value < 0) {
                callback(new Error("服务费比例不能大于1且不能小于0"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      page: {},
      parentId: "",
      lastParentId: "",
    };
  },
  mixins: [loadMixin, dialogMixin],
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  mounted() {
    this.getList();
    this.page = this.$refs.commonTable.page;
  },
  computed: {
    dialogData() {
      const params = {
        levelName: this.dialogModel.levelName,
        fee: this.dialogModel.fee,
        parentId: this.parentId,
        withdrawFee: this.dialogModel.withdrawFee,
        withdrawRate: this.dialogModel.withdrawRate * 100,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId
        ? OrganService.memberupgradeEdit
        : OrganService.memberupgradeInsert;
    },
    ...mapGetters(["userId"]),
  },
  watch: {},
  methods: {
    openDialog(item) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.parentId = this.dialogModel.parentId;
        this.dialogModel.withdrawRate = this.dialogModel.withdrawRate / 100;
      }
      this.$refs.formDialog.open();
    },
    getList() {
      this.doLoad(
        this.submitService,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;
            if (this.tableData.length) {
              for (let i = 0; i < this.tableData.length; i++) {
                if (i == this.tableData.length - 1) {
                  this.lastParentId = this.tableData[i].id;
                  this.parentId = this.lastParentId;
                }
              }
            } else {
              this.parentId = 0;
            }

            this.page.currentPage = result.current;
            this.page.total = result.total;
            this.page.pageSize = result.size;
          });
        },
        "信息获取失败"
      );
    },
    deleteInfo(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        OrganService.memberupgradeDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    dialogClose() {
      this.dialogModel = {
        levelName: "",
        fee: undefined,
        withdrawRate: undefined,
        withdrawFee: undefined,
      };
      this.itemId = "";
      this.parentId = this.lastParentId;
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.memLevelManageList;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    formatterTablewithdrawRate(row, column, cellValue, index) {
      let value = "--";

      return (value = cellValue / 100);
    },
  },
};
</script>

<style scoped>
.type-title {
  font-size: 20px;
  color: #000;
}

.type-msg {
  font-size: 20px;
  color: #aaaaaa;
  margin-left: 10px;
}

.box-card {
  margin-bottom: 30px;
}

.unit {
  margin-left: 10px;
  color: #aaaaaa;
}

.levelList {
  display: flex;
  flex-wrap: wrap;
}

.type-box {
  margin-bottom: 22px;
}

.people-check {
  text-align: right;
  padding-right: 12px;
  margin-bottom: 20px;
  padding-left: 90px;
}

.up-people-list {
  padding-left: 90px;
}

.upPeople-desc {
  margin-bottom: 20px;
  font-weight: bold;
}

.pad-right {
  padding-right: 70px;
}

.pad-left {
  padding-left: 90px;
}

.mar_bot {
  margin-bottom: 20px;
}

.notice-text {
  color: #aaaaaa;
  margin-top: -10px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/MemberUpgrade.vue